<template>
    <TooltipedTextField
        v-model="mValue"
        :label="label"
        :placeholder="placeholder"
        :tooltip="tooltip"
        :tooltipIcon="tooltipIcon"
        :errorMessage="errorMessage"
        @blur="blur"
    />
</template>

<script>
import TooltipedTextField from '@/CMS/editor/components/TooltipedTextField.vue'

const MIN_VALUE = 1
const MAX_VALUE = 12

export default {
    name: 'NumberColumnsTextField',
    props: {
        value: { type: [Number, String] },
        label: { type: String },
        placeholder: { type: String },
        tooltip: { type: String },
        tooltipIcon: { type: String, default: 'fas fa-question-circle' },
    },
    computed: {
        mValue: {
            get () { return this.value },
            set (val) { this.$emit('input', val) },
        },
        hasInvalidValue() {
            if (typeof this.mValue === 'number' && Number.isInteger(this.mValue)) {
                return false
            }

            if (typeof this.mValue === 'string' && this.mValue && !(/\D/.test(this.mValue))) {
                return false
            }

            return true
        },
        hasMinValueIssue() {
            return this.mValue < MIN_VALUE
        },
        hasMaxValueIssue() {
            return this.mValue > MAX_VALUE
        },
        errorMessage() {
            if (this.hasInvalidValue) {
                return `The value entered is invalid.`
            }

            if (this.hasMinValueIssue) {
                return `The minimum value is 1`
            }

            if (this.hasMaxValueIssue) {
                return `The maximum value is 12`
            }

            return ''
        },
    },
    methods: {
        blur() {
            if (this.hasInvalidValue || this.hasMinValueIssue) {
                this.mValue = MIN_VALUE
                return
            }

            if (this.hasMaxValueIssue) {
                this.mValue = MAX_VALUE
            }
        },
    },
    components: {
        TooltipedTextField,
    },
}
</script>
